import { resetAddress } from 'src/state/address/address-slice';
import { resetNewAddress } from 'src/state/request/request-slice';
import { AppDispatch } from 'src/state/types';

export const resetRequestsForNewAddressActionCreator = () => (dispatch: AppDispatch) => {
  dispatch(resetAddress());
  dispatch(resetNewAddress());
};
